<template>
  <create-survey-template-view :key="$route.params.key"></create-survey-template-view>
</template>

<script>
import CreateSurveyTemplateView from "@/views/main/CreateSurveyTemplateView";

export default {
  name: "EditSurveyTemplateView",
  components: {CreateSurveyTemplateView},
  mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
    }
  },
}
</script>

<style scoped>

</style>
